module.exports = __webpack_public_path__ + "static/media/0013.0d590f5d.jpg";